import { render, staticRenderFns } from "./name_modal.vue?vue&type=template&id=38f54ba2&"
import script from "./name_modal.vue?vue&type=script&lang=js&"
export * from "./name_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports